export default __webpack_public_path__ + "static/media/image@3x.ff8786da.png";